import moment from 'moment';

export const daysFromUntil = date => {
  const diff = moment(date)
  .startOf('day')
  .diff(moment().startOf('day'), 'days');
  return diff < -30
    ? '> month ago'
    : diff < -7
      ? '> week ago'
      : diff < -1
        ? `${Math.abs(diff)} days ago`
        : diff === -1
          ? 'Yesterday'
          : diff === 0
            ? 'Today'
            : diff === 1
              ? 'Tomorrow'
              : diff < 7
                ? `This ${moment(date).format('dddd')}`
                : diff < 30
                  ? `In ${diff} days`
                  : diff < 60
                    ? 'In > a month'
                    : `In > ${Math.floor(diff / 30)} months`;
};

export const isCurrent = start => moment().isAfter(moment(start));

export const formatDuration = (diff) => {
  const duration = moment.duration(diff);
  const durMinutes = duration.minutes() ? `${duration.minutes()} min ` : '';
  const durSeconds = duration.seconds() ? `${duration.seconds()} sec` : '';
  return durMinutes + durSeconds;
};
